var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8067 3.19891C12.0667 2.93891 12.0667 2.50557 11.8067 2.25891L10.2467 0.698906C10 0.438906 9.56667 0.438906 9.30667 0.698906L8.08 1.91891L10.58 4.41891M0 10.0056V12.5056H2.5L9.87333 5.12557L7.37333 2.62557L0 10.0056Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconDark);
export default __webpack_public_path__ + "static/media/EditIconDark.a915fe91f78f0c1b6e372ccbf6252f94.svg";
export { ForwardRef as ReactComponent };